// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/app/issue-tracker/notes-dialog/notes-dialog.component.less"],"names":[],"mappings":"AAEA;EACI,iBAAA;AADJ","sourcesContent":["@import (reference) url('../../../assets/ngb-modals.less');\n\nlabel {\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
